import { useMemo } from "react";
import { FiCheck, FiMail, FiPackage } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import PageMeta from "./PageMeta";
import { money } from "./ProductCard";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

function PaySuccess() {
  const { state, search } = useLocation();
  const paymentState = new URLSearchParams(search).get("state");
  const order = useMemo(() => {
    const checkoutConfig = siteConfig.checkout || {};
    const storageKey =
      checkoutConfig.lastOrderStorageKey || "lastStorefrontOrder";
    try {
      const storedOrder = JSON.parse(window.sessionStorage.getItem(storageKey));
      const candidate = state?.orderNumber ? state : storedOrder;
      const expiresAt = Number(candidate?.expiresAt);
      return candidate?.orderNumber &&
        Number.isFinite(expiresAt) &&
        expiresAt > Date.now()
        ? candidate
        : null;
    } catch {
      return null;
    }
  }, [state]);

  if (paymentState === "cancel") {
    return (
      <main className="success-page">
        <PageMeta title="Payment cancelled" noIndex />
        <section className="success-card">
          <p className="eyebrow">Payment cancelled</p>
          <h1>Your order has not been charged.</h1>
          <p className="success-card__lede">Your basket is still available. You can return to checkout whenever you are ready.</p>
          <div className="success-card__actions">
            <Link className="button button--primary" to="/checkout">Return to checkout</Link>
            <Link className="text-link" to="/cartpage">View cart</Link>
          </div>
        </section>
      </main>
    );
  }

  if (!order || paymentState !== "success") {
    return (
      <main className="success-page">
        <PageMeta title="No recent order" noIndex />
        <section className="success-card">
          <p className="eyebrow">Payment status</p>
          <h1>There is no recent order to show.</h1>
          <p className="success-card__lede">
            Complete checkout to see your payment confirmation.
          </p>
          <div className="success-card__actions">
            <Link className="button button--primary" to="/cartpage">View cart</Link>
            <Link className="text-link" to="/shop">Browse the pantry <span aria-hidden="true">→</span></Link>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="success-page">
      <PageMeta title="Order received" noIndex />
      <section className="success-card">
        <div className="success-card__mark" aria-hidden="true">
          <FiCheck />
        </div>
        <p className="eyebrow">Grazie{order.firstName ? `, ${order.firstName}` : ""}</p>
        <h1>Your payment was successful.</h1>
        <p className="success-card__lede">
          Your order has been received. A confirmation will be sent to{" "}
          {order.email || "your email"}.
        </p>

        <dl className="success-details">
          <div><dt>Order number</dt><dd>{order.orderNumber}</dd></div>
          <div><dt>Order total</dt><dd>{money.format(order.total)}</dd></div>
          <div><dt>Items</dt><dd>{order.itemCount}</dd></div>
        </dl>

        <div className="success-timeline">
          <div><FiMail aria-hidden="true" /><span><strong>Confirmation</strong><small>Order details and receipt</small></span></div>
          <div><FiPackage aria-hidden="true" /><span><strong>Packed with care</strong><small>{siteConfig.shipping.processingTime}</small></span></div>
        </div>

        <div className="success-card__actions">
          <Link className="button button--primary" to="/shop">Keep shopping</Link>
          <Link className="text-link" to="/">Return home <span aria-hidden="true">→</span></Link>
        </div>
      </section>
    </main>
  );
}

export default PaySuccess;
